import { render } from "./RequiredDisclosure.vue?vue&type=template&id=4cd091ea&scoped=true"
import script from "./RequiredDisclosure.vue?vue&type=script&lang=js"
export * from "./RequiredDisclosure.vue?vue&type=script&lang=js"

import "./RequiredDisclosure.vue?vue&type=style&index=0&id=4cd091ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cd091ea"]])

export default __exports__